import { Button, Card, CardActions, CardContent, Grid } from "@mui/material";
import QuickLoadResourceCreateComponent from "./QuickLoadResourceCreateComponent";
import MainCard from 'ui-component/cards/MainCard';
import TitleService from "title-service";
import { useDispatch, useSelector } from "react-redux";
import { get_all_media, is_media_busy } from "features/media/media-slice";
import { create_checkout_session, get_all_media_data, get_all_media_resources, get_curated_media_list, update_curated_media_list, update_media } from "features/auto-thunks";
import { getUserClaims } from "features/application/application-slice";
import { get_all_processedMedia, is_processedMedia_busy } from "features/processedMedia/processedMedia-slice";
import { get_all_curatedMediaList, is_curatedMediaList_busy } from "features/curatedMediaList/curatedMediaList-slice";
import { m } from "framer-motion";
import { MediaType, ResourcePropertyType } from "features/enumerations";
import { getProcessedMediaState } from "./CacheServices";
import { ResolveStorageUrl } from "features/firebase-app";
import { CuratedMediaList } from "models";
import { useEffect, useState } from "react";

export default function Tooling() {
    const medias = useSelector(get_all_media);
    const processedMedias = useSelector(get_all_processedMedia);
    const curatedMediaList = useSelector(get_all_curatedMediaList);
    const medias_busy = useSelector(is_media_busy);
    const processedMedia_busy = useSelector(is_processedMedia_busy);
    const curatedMediaList_busy = useSelector(is_curatedMediaList_busy);
    const busy = medias_busy || processedMedia_busy || curatedMediaList_busy;
    let claims = useSelector(getUserClaims);
    const [sessionUrl, setSessionUrl] = useState(null);
    const dispatch = useDispatch();
    useEffect(() => {
        if (claims?.user) {
            dispatch(create_checkout_session({
                userId: claims?.user,
                callback: ((success, response) => {
                    console.log(success)
                    if (success) {
                        console.log(response)
                        setSessionUrl(response.data.url);
                    }
                })
            }))
        }
    }, [claims?.user])
    return (
        <>
            <MainCard title={TitleService('Tools')} content={false}>
                <CardContent>
                    {sessionUrl ? <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} lg={4}>
                            <Button onClick={() => {
                                window.open(sessionUrl, '_self');
                            }} >Buy</Button>
                        </Grid>
                    </Grid> : null}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} lg={4}>
                            <QuickLoadResourceCreateComponent />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} lg={4}>
                            <Button onClick={() => {
                                dispatch(get_all_media_resources({ playerId: claims?.player }));
                            }} >
                                Processed Medias {processedMedias.length}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={2}>
                            <Button onClick={() => {
                                for (let i = 0; i < medias.length; i++) {
                                    let m = medias[i];
                                    if (claims.user) {
                                        dispatch(get_all_media_data({
                                            owner: m.owner,
                                            userId: claims.user,
                                            playerId: claims?.player
                                        }))
                                    }
                                }
                            }} >
                                Media {medias.length}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={2}>
                            <Button onClick={() => {
                                dispatch(get_curated_media_list({ playerId: claims?.player }))
                            }} >
                                Curated Media {curatedMediaList.length}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={4}>
                            <Button disabled={busy} onClick={async () => {
                                for (let i = 0; i < processedMedias.length; i++) {
                                    let processedMedia = processedMedias[i];
                                    let thumbNails = getProcessedMediaState(processedMedia?.states, ResourcePropertyType.Thumbnail, MediaType.IMAGE, 300);
                                    if (thumbNails[0]) {
                                        let found_media = medias.find(x => x.id === (processedMedia.media as any));
                                        if (found_media && !found_media?.thumbnailDefaultUrl) {
                                            await ResolveStorageUrl(thumbNails[0].location).then(async (res) => {
                                                await dispatch(update_media({
                                                    playerId: claims?.player,
                                                    userId: claims?.user,
                                                    media: {
                                                        ...found_media,
                                                        thumbnailDefaultUrl: res
                                                    }
                                                }))
                                            });
                                        }
                                    }
                                }
                                for (let i = 0; i < curatedMediaList.length; i++) {
                                    let curated = curatedMediaList[i];
                                    if (curated.media.some((m) => !m.thumbnailDefaultUrl)) {
                                        let c: CuratedMediaList = JSON.parse(JSON.stringify(curated));
                                        let updated = false;
                                        for (let j = 0; j < c.media.length; j++) {
                                            let m = c.media[j];
                                            if (!m.thumbnailDefaultUrl) {

                                                let pm = processedMedias.find(t => (t.media as any) === m.id);
                                                if (pm) {
                                                    let thumbNails = getProcessedMediaState(pm?.states, ResourcePropertyType.Thumbnail, MediaType.IMAGE, 300);
                                                    if (thumbNails[0]) {
                                                        updated = true;
                                                        m.thumbnailDefaultUrl = await ResolveStorageUrl(thumbNails[0].location);
                                                    }
                                                }
                                            }
                                        }
                                        if (updated) {
                                            await dispatch(update_curated_media_list({
                                                playerId: claims?.player,
                                                userId: claims?.user,
                                                curatedMediaList: {
                                                    ...c
                                                }
                                            }))
                                        }
                                    }
                                }
                            }} >
                                Fix set default thumbnail urils.
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                </CardActions>
            </MainCard>

        </>
    )
}